<template>
    <v-layout row wrap justify-space-between>
        <!-- Header -->
        <v-flex xs12 sm12 md12 lg12 xl12>
            <PageTitle icon="mdi-view-dashboard" main="Automações" sub="Campanhas" />
        </v-flex>
        
        <!-- Kpis -->
        <v-flex xs12 sm12 md12 lg12 xl12>
            <Filters/>
        </v-flex>
        <v-flex xs12 sm12 md12 lg12 xl12>
            <v-layout row wrap justify-start>
                <v-flex 
                    v-for="f in registers"
                    :key="f.name"
                    pa-3
                    xs12 sm6 md4 lg4 xl4>
                    <Sparkline 
                        v-if="f.opens"
                        :title="f.name"
                        :subheading="[`${f.newSends} Novos Envios`,`${f.newOpens} Novas Aberturas`, `${f.newClicks} Novos Cliques`]"
                        :progressBar="[{text: 'Aberturas', value: f.opens/f.sends*100},{text: 'Cliques', value: f.clicks/f.sends*100}]"
                        :caption="periodScope.text"
                        :labels="f.data.map(x => (periodScope.value === 'last24h') ? new Date(x.createdAt).getHours() : new Date(x.createdAt).getDate()).reverse()"
                        :value="f.data.map(x => x.newOpens || 0).reverse()"
                    />
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
import PageTitle from '../templates/PageTitle'
import Filters from './Filters'
import Sparkline from './Sparkline'
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapGetters, mapActions } = createNamespacedHelpers('registers')

export default {
    name: 'Automations',
    components: { PageTitle, Filters, Sparkline },
    props: ['id'],
    data: function() {
        return {
            registers: []
        }
    },
    computed: {
	    ...mapGetters(['automations', 'periodScope', 'campaignsLast24h', 'campaignsLastWeek']),
    },
    methods: {
        ...mapActions(['loadRecords']),
        
        initialize() {
            this.loadRecords({ scope: 'campaignsLast24h', path: 'automations', segment: `${this.id}/campaignsLast24h` })
                .then(() => {if (this.registers.length === 0) this.registers = this.campaignsLast24h} )
                .catch(e => console.log(e))
            this.loadRecords({ scope: 'campaignsLastWeek', path: 'automations', segment: `${this.id}/campaignsLastWeek` })
                .catch(e => console.log(e))
        }
    },
    watch: {
        periodScope (val) {
            this.registers = this[`campaigns${val.value.charAt(0).toUpperCase()+val.value.slice(1)}`]
        },
        id (val) {
            this.initialize()
        },
    },
    created() {
        this.initialize()
        
        setInterval(() => {
            this.initialize()
        }, 1000*60);
    }
}
</script>

<style>
</style>
